// extracted by mini-css-extract-plugin
export var dropdownIcon = "_rb-6";
export var imgContainer = "_rb-3";
export var menuIcon = "_rb-5";
export var pillWrapper = "_rb-2";
export var pillsContainer = "_rb-1";
export var subscriptionCard = "_rb-0";
export var subscriptionLogo = "_rb-4";